import React from "react"
import Button from "../../../../components/button";
import { urls } from "../../../../constants";
import * as s from './css/come-funziona.module.css'

const ComeFunziona = ({ project }) => {

    return (
        <div id="come_funziona_container" className={`container-grid ${s.container}`}>
            <div className="col-span-4 desktop:col-span-8 desktop:col-start-3">
                <div className={`text-center font-bd text-center ${s.title}`}>Approfitta dei vantaggi di Tinaba Hit</div>
            </div>
            <div className={`col-span-4 desktop:col-span-4 desktop:col-start-5 ${s.containerButton}`}>
                <div className="text-center mx-4 desktop:mx-0">
                    <div>
                        <Button id="btnPreorder" className={`${s.btnPreorder} attiva-tinaba-hit-btn`} onClick={() => {
                            window.location.href = urls.ATTIVA_TINABA_HIT;
                        }}>
                            Come attivare Tinaba Hit
                        </Button>
                    </div>
                </div>
            </div>
            <div className={`col-span-4 desktop:col-span-8 desktop:col-start-3 ${s.containerVideo}`}>
                <div className="text-center mx-4 desktop:mx-0">
                    <div className={s.boxVideo} style={{ position: 'relative', paddingBottom: '56%' }}>
                        <iframe title="Come funziona" style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }} src={project.__youtubeVideo} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ComeFunziona